<template>
  <div id="sign_up">
    <a href="javascript: history.go(-1)">
      <div class="button-close has-text-right mr-5 mt-5">
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 1L1 25"
            stroke="#9D9D9D"
            stroke-opacity="0.29"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1 1L25 25"
            stroke="#9D9D9D"
            stroke-opacity="0.29"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </a>
   <div class="container-content-create-account has-text-left mt-5">

      <div class="title-header-section-create-account">
        <p class="title-section text-basier has-text-left title-regular dark-blue-emitus">Crear <br> Cuenta</p>
      </div>

      <!-- Signup Form -->
      <form >

        <div class="name-user is-flex mt-5">
          <!-- Firstname -->
          <b-field
            label="Nombre(s)"
            :message="mensajeFirst"
            :type="messageTypeFirst"

          >
            <b-input
              v-on:focusout.native="ValidityFirstname"
              v-on:focusin.native="clearValidityFirst"
              id="firstname"
              v-model="firstname"
              autocomplete="off"
            >
            </b-input>
          </b-field>

          <!-- Lastname -->
          <b-field
            class="ml-2"
            label="Apellido(s)"
            :message="mensajeLast"
            :type="messageTypeLast"
          >
            <b-input
              v-on:focusout.native="ValidityLastname"
              v-on:focusin.native="clearValidityLast"
              id="lastname"
              v-model="lastname"
              autocomplete="off"
            >
            </b-input>
          </b-field>
        </div>

        <!-- eMail -->
        <b-field
          class="mt-3"
          label="Correo Electrónico"
          :message="mensajeEmail"
          :type="messageTypeEmail"
        >
          <b-input
            v-on:focusout.native="ValidityEmail"
            v-on:focusin.native="clearValidityEmail"
            :validation-message= mensaje
            id="email"
            placeholder="youremail@something.com"
            v-model="email"
            autocomplete="off"
          >
          </b-input>
        </b-field>

        <!-- Password -->
        <b-field
          class="mt-5 "
          label="Contraseña"
          :message="mensajePassword"
          :type="messageTypePassword"
        >
          <b-input
          v-on:focusout.native="ValidityPassword"
            v-on:focusin.native="clearValidityPassword"
            password-reveal
            id="password"
            type="password"
            v-model="password"
            autocomplete="off"
          >
          </b-input>
        </b-field>

        <!-- CTA Button -->
        <button class="button-primary-medium mt-6" @click.prevent="signup">Registrarme</button>
        <div v-if="loader">
          <Loading/>
        </div>
        <div style="margin-top: 28px;">
          <router-link :to="{name: 'Login'}" class="text-basier" style="font-size: 13px; color: #393939;">Ya tengo cuenta <span style="font-weight: bold; text-decoration: underline; color: #9A55F2;">Ingresar</span> </router-link>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/modals/loader.vue'
import UserService from '@/services/UserService'
import firebase from 'firebase/app'
import 'firebase/auth'
import dayjs from 'dayjs'
import MixpanelService from '@/services/MixpanelService'

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  components: {
    Loading
  },
  name: 'SignupWithEmail',

  metaInfo: {
    title: 'emitus | Signup'
  },
  data () {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      mensajeEmail: '',
      mensajePassword: '',
      mensajeFirst: '',
      mensajeLast: '',
      messageTypeEmail: '',
      messageTypePassword: '',
      messageTypeFirst: '',
      messageTypeLast: '',
      valid: true,
      mensaje: '',
      authUser: null,
      passwordError: null,
      generalError: null,
      loader: false
    }
  },
  created () {
    firebase.auth().onAuthStateChanged(user => {
      this.authUser = user
    })
  },
  mounted () {
  },
  methods: {
    // Sign Up with Password --------
    async signup () {
      const timezone = dayjs.tz.guess()
      if (this.firstname && this.lastname && this.email && this.password) {
        this.valid = true
      }
      await this.ValidityFirstname()
      await this.ValidityLastname()
      await this.ValidityEmail()
      await this.ValidityPassword()


      if (this.valid) {
        console.log('--------------------- hhhhhh99')
        this.loader = true
        await firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
          .catch(err => {
            this.generalError = err.message
            this.danger(this.generalError)
          })

        const newUser = await UserService.SignupFirebase(
          this.firstname,
          this.lastname,
          this.authUser.email,
          this.authUser.uid,
          timezone
        )

        if (newUser.status === 201) {
          // console.log('99', newUser)
          MixpanelService.signUp(newUser)
          this.notify.$emit('updateData')
          this.$router.push('/welcome')
        }

        // firebase.auth().currentUser.sendEmailVerification()
        //   .then(() => {
        //     alert('Please check yout email to verify we have it right')
        //   })

        // if (signup) {
        //   this.$router.push('/welcome')
        // } else {
        //   this.$router.push('/panel/me/edit-me')
        // }
      }
    },
    ValidityFirstname () {
      if (!this.firstname) {
        this.mensajeFirst = 'Cuál es tu nombre'
        this.messageTypeFirst = 'is-primary'
        this.valid = false
      } else {
        this.mensajeFirst = ''
        // this.messageTypeFirst = 'is-success'
      }
    },
    ValidityLastname () {
      if (!this.lastname) {
        this.mensajeLast = 'Cuál es tu apellido'
        this.messageTypeLast = 'is-primary'
        this.valid = false
      } else {
        this.mensajeLast = ''
        // this.messageTypeLast = 'is-success'
      }
    },
    async ValidityEmail () {
      try {
        const response = await firebase.auth().fetchSignInMethodsForEmail(this.email)
        if (response.length > 0) {
          this.mensajeEmail = 'Este correo ya está registrado'
          this.messageTypeEmail = 'is-primary'
          this.valid = false
        } else if (!this.validEmail(this.email)) {
          this.mensajeEmail = 'Algo está mal. Revisa to correo electrónico.'
          this.messageTypeEmail = 'is-primary'
          this.valid = false
        } else {
          this.mensajeEmail = ''
          // this.messageTypeEmail = 'is-success'
        }
      } catch (error) {
        this.mensajeEmail = error.message
        this.messageTypeEmail = 'is-primary'
        this.valid = false
      }
    },
    ValidityPassword () {
      if (this.password.length < 6 || this.password === '') {
        this.mensajePassword = 'La contraseña debe tener al menos 6 caracteres'
        this.messageTypePassword = 'is-primary'
        this.valid = false
      } else {
        this.mensajePassword = ''
        this.messageTypePassword = ''
      }
    },
    clearValidityFirst () {
      this.messageTypeFirst = ''
      this.mensajeFirst = ''
    },
    clearValidityLast () {
      this.messageTypeLast = ''
      this.mensajeLast = ''
    },
    clearValidityEmail () {
      this.messageTypeEmail = ''
      this.mensajeEmail = ''
    },
    clearValidityPassword () {
      this.mensajePassword = ''
      this.mensajePassword = ''
    },

    // Danger Toast
    danger (msg) {
      this.$buefy.toast.open({
        duration: 5000,
        message: msg,
        position: 'is-bottom',
        type: 'is-primary'
      })
    },
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style scoped>
/* #sign_up */

#sign_up input:-webkit-autofill,
#sign_up input:-webkit-autofill:hover,
#sign_up input:-webkit-autofill:active,
#sign_up input:-webkit-autofill:focus {
    background-color: #FFFFFF !important;
    color: #555 !important;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #555555 !important;
}
#sign_up .has_required {
  text-decoration: line-through;
  color:#6e3dea;
}
#sign_up form {
    margin-top: 30px;
    width: 90%;
    margin: auto;
    max-width: 360px;
}

#sign_up .title-header-section-create-account {
  margin-top: 35px;
  margin-bottom: 45px;
  margin-left: 5%;
}
#sign_up .container-content-create-account {
  width: 85%;
}

#sign_up input, #sign_up select {
    height: 45px !important;
}

#sign_up input::placeholder {
  font-family: 'Nunito' !important;
}

#sign_up input:hover {
  border-color: #EEEEEE;
}

</style>
